import React from 'react';

import { CheckboxListItem, CheckboxListItemProps } from 'shared/components';

import { BUTTON_ICON } from '../../constants';

import { useShowFavouriteStations } from 'entities/stations';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';

export const FavouriteStationsCheckboxListItem = ({
  onChange,
  checked
}: FavouriteStationsCheckboxListItemProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const showFavouriteStations = useShowFavouriteStations();

  if (!showFavouriteStations) {
    return null;
  }

  return (
    <div className={classes.container}>
      <CheckboxListItem
        onChange={onChange}
        checked={checked}
        icon={BUTTON_ICON}
        title={formatMessage({ id: 'favouriteStations' })}
      />
    </div>
  )
};

export interface FavouriteStationsCheckboxListItemProps extends Pick<
  CheckboxListItemProps,
  'onChange' | 'checked'
> {}
